import { DrawingType, RoiUpdateDetails, RulerUpdateDetails } from '../constants';
import { getCanvasPointerPosition } from '../utils';
import { getNewId } from 'utils/Global';
import TransformPoints from 'components/plateviewer/well/TransformPoints';

let rulerDrawing: RulerUpdateDetails = null;
let isDrawingFirstClick: boolean = false;

export const useRulerCreateHandlers = (
  drawingColor: string,
  tpObject: TransformPoints,
) => {
  const onMouseDown: (e) => { drawing: RoiUpdateDetails; type: DrawingType } = (e) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX1, dbY1] = tpObject.FromCanvasToDb(x, y);
    rulerDrawing = {
      id: getNewId(),
      x1: x,
      y1: y,
      dbX1,
      dbY1,
      color: drawingColor,
      zIndex: 0,
      isNewDrawing: true,
    };
    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: RoiUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX2, dbY2] = tpObject.FromCanvasToDb(x, y);
    rulerDrawing = {
      ...rulerDrawing,
      x2: x,
      y2: y,
      dbX2,
      dbY2,
    };
    const drawingData = {
      drawing: rulerDrawing,
      type: DrawingType.Ruler,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp: (e) => { drawing: RoiUpdateDetails; type: DrawingType } = (e) => {
    if (!isDrawingFirstClick) {
      rulerDrawing = {
        ...rulerDrawing,
        isNewDrawing: false,
      };
      return { drawing: rulerDrawing, type: DrawingType.Ruler };
    }
    isDrawingFirstClick = false;
    return null;
  };

  return { onMouseDown, onMouseMove, onMouseUp };
};
